import {gql} from '@apollo/client'
import {EMAIL_TYPES} from 'consts/emailType'

export const CUSTOM_EMAIL = gql`
  query customEmail($emailType: EmailType!) {
    defaultEmail(emailType: $emailType) {
      id
      emailType
      subject
      header
      footer
    }

    client {
      id
      customEmail(emailType: $emailType) {
        id
        emailType
        subject
        body
      }
    }
  }
`

export interface CustomEmailQueryVariables {
  emailType: keyof typeof EMAIL_TYPES
}

export interface CustomEmailQueryResult {
  defaultEmail?: DefaultEmail
  client: {
    customEmail?: CustomEmail
  }
}

export interface DefaultEmail {
  id: string
  emailType: keyof typeof EMAIL_TYPES
  subject?: string
  header?: string
  footer?: string
}

export interface CustomEmail {
  id: string
  emailType: keyof typeof EMAIL_TYPES
  subject?: string
  body?: string
}

export const UPDATE_CUSTOM_EMAIL = gql`
  mutation updateCustomEmail($input: UpdateCustomEmailInput!) {
    updateCustomEmail(input: $input) {
      customEmail {
        id
        emailType
        subject
        body
      }
    }
  }
`

export interface UpdateCustomEmailQueryVariables {
  input: {
    emailType: keyof typeof EMAIL_TYPES
    subject?: string
    body?: string
  }
}
